import timelimit from '~/constants/vp/timelimit';
import Client from '~/types/api/api-module';
import ApiOptions from '../api-options';

const PDAM_URL = `${process.env.API_V4_HOST}/pdam`;

export default Client.wrap({
  Public: {
    async payPdam(userId, { transaction, customerPhone, method, voucherCode }) {
      const invoiceResponse = await this.registerInvoice(transaction.id, transaction.type, method, voucherCode);
      if (invoiceResponse.meta.http_status !== 201) throw invoiceResponse;
      if (customerPhone !== '') {
        this.createAgentTransactionDetail(invoiceResponse.data.payment_id, transaction.customer_number, customerPhone);
      }
      const paymentResponse = await this.makePayment(userId, invoiceResponse.data.payment_id, method);
      if (paymentResponse.meta.http_status !== 200) throw paymentResponse;
      return {
        paymentResponse,
        invoiceResponse,
      };
    },
  },
  Private: {
    postPdamTransaction({ customerNumber, operatorId }) {
      const requestLimit = { time: timelimit.deposit, additionalKey: customerNumber };
      const requestPayload = { customer_number: customerNumber, operator_id: operatorId };
      return this.post(`${PDAM_URL}/transactions`, 'user', new ApiOptions({ requestPayload, requestLimit }));
    },
    postPdamInquiry(requestPayload) {
      return this.post(`${PDAM_URL}/inquiries`, 'public', new ApiOptions({ requestPayload }));
    },
    getPdamTransaction(id) {
      return this.get(`${PDAM_URL}/transactions/${id}`, 'user', new ApiOptions());
    },
    getPdamOperators() {
      return this.get(`${PDAM_URL}/operators`, 'public', new ApiOptions());
    },
  },
});
